export default __webpack_public_path__ + "static/media/antibotbadge.dc7a9a71.png";